import { BrowserRouter, Route, Routes } from "react-router-dom";
import StudentLogin from "./pages/StudentPortal/StudentLogin";
import StudentRegistration from "./pages/StudentPortal/StudentRegistration";
import Course from "./pages/StudentPortal/Course";
import Leaderboard from "./pages/StudentPortal/Leaderboard";
import AdminLogin from "./pages/AdminPortal/AdminLogin";
import Dashboard from "./pages/AdminPortal/Dashboard";
import Videos from "./pages/AdminPortal/Videos";
import AddVideo from "./pages/AdminPortal/AddVideo";
import EditVideo from "./pages/AdminPortal/EditVideo";
import Assignment from "./pages/AdminPortal/Assignment";
import AddAssignment from "./pages/AdminPortal/AddAssignment";
import EditAssignment from "./pages/AdminPortal/EditAssignment";
import AssignmentMark from "./pages/AdminPortal/AssignmentMark";
import Quizzes from "./pages/AdminPortal/Quizzes";
import useAuthCheck from "./hooks/useAuthCheck";
import PublicRoute from "./components/PublicRoute";
import StudentRoute from "./components/StudentPortal/StudentRoute";
import AdminRoute from "./components/AdminPortal/AdminRoute";
import Quiz from "./pages/StudentPortal/Quiz";
import AddQuize from "./pages/AdminPortal/AddQuize";
import EditQuize from "./pages/AdminPortal/EditQuize";

function App() {
  const authChecked = useAuthCheck();
  return !authChecked ? (
    <div>Checking authentication....</div>
  ) : (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <PublicRoute>
              <StudentLogin />
            </PublicRoute>
          }
        />
        <Route
          path="/register"
          element={
            <PublicRoute>
              <StudentRegistration />
            </PublicRoute>
          }
        />
        <Route
          path={`/course/`}
          element={
            <StudentRoute>
              <Course />
            </StudentRoute>
          }
        />
        <Route
          path={`/quiz/:videoId`}
          element={
            <StudentRoute>
              <Quiz />
            </StudentRoute>
          }
        />
        <Route
          path={`/course/:videoId`}
          element={
            <StudentRoute>
              <Course />
            </StudentRoute>
          }
        />
        <Route
          path="/leaderboard"
          element={
            <StudentRoute>
              <Leaderboard />
            </StudentRoute>
          }
        />
        <Route
          path="/admin/"
          element={
            <PublicRoute>
              <AdminLogin />
            </PublicRoute>
          }
        />
        <Route
          path="/admin/dashboard"
          element={
            <AdminRoute>
              <Dashboard />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/videos"
          element={
            <AdminRoute>
              <Videos />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/addvideo"
          element={
            <AdminRoute>
              <AddVideo />
            </AdminRoute>
          }
        />
        <Route
          path={`/admin/editvideo/:videoId`}
          element={
            <AdminRoute>
              <EditVideo />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/assignment"
          element={
            <AdminRoute>
              <Assignment />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/addassignment"
          element={
            <AdminRoute>
              <AddAssignment />
            </AdminRoute>
          }
        />
        <Route
          path={`/admin/editassignment/:assignmentId`}
          element={
            <AdminRoute>
              <EditAssignment />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/assignmentmark"
          element={
            <AdminRoute>
              <AssignmentMark />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/quizzes"
          element={
            <AdminRoute>
              <Quizzes />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/addquize"
          element={
            <AdminRoute>
              <AddQuize />
            </AdminRoute>
          }
        />
        <Route
          path={`/admin/editquize/:quizeId`}
          element={
            <AdminRoute>
              <EditQuize />
            </AdminRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
